import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';  
import { useLocation } from 'react-router-dom';  
import useCustomNavigate from '../../common_nextgen/common_components/Navigation/NextGenNavigation';  
import Form from '../../common_nextgen/common_components/form/Form';  
import { PRICE_SCHEDULE_MODES} from '../../common_nextgen/utils/Constants';  
import { useAxios } from '../../common_nextgen/axios/AxiosHelper';  
import ConfirmationModal from '../../common_nextgen/common_components/Modal/ConfirmationModal';  
import { useToast } from '../../common_nextgen/hooks/ToastContext';  
import FunctionKeys from '../../common_nextgen/common_components/FunctionKeys/FunctionKeys';  

import { formFields, screenInfo } from './CopayScheduleStepFormConfig';
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";  
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";

  
const CopayScheduleStepForm = ({ mode,intialSchedule,selectMode ,hideModal,paramsDesc,sourceData}) => {  
  const { COPAY_SCHEDULE_STEPS } =
  ROUTE_PATHS; 
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();  
  const [stateVal, setStateVal] = useState(location.state || []);
  let { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);
  const { 
    selectedSchedules = [], 
    previousScreen = COPAY_SCHEDULE_STEPS, 
    currentIndex: initialIndex = 0,
    cscCopayScheduleName, 
    cshCopayScheduleDesc ,
    formData: baseFormData = {},
    lookupMode: initialLookupMode = false,
    lookupScreen,
    lookupParams,
    navigateData,
    externalMode: initialExternalMode = false,
  }=useMemo(() => {const{
    selectedSchedules ,
    previousScreen , 
    currentIndex,
    cscCopayScheduleName, 
    cshCopayScheduleDesc ,
    formData,
    lookupMode,
    lookupScreen,
    lookupParams,
    navigateData,
    externalMode
  }=currentState;
    return{
      selectedSchedules ,
      previousScreen , 
      currentIndex,
      cscCopayScheduleName, 
      cshCopayScheduleDesc ,
      formData,
      lookupMode,
      lookupScreen,
      lookupParams,
      navigateData,
      externalMode
    }
  },[currentState])

  const navigateToPage = useCustomNavigate();  

  const [selectedOption, setSelectedOption] = useState('no');  
  const [currentIndex, setCurrentIndex] = useState(initialIndex);  
  const [currentMode, setCurrentMode] = useState(mode);  
  const [initialFormData, setInitialFormData] = useState({});  
  const [dataForSubmission, setDataForSubmission] = useState({});  
  const [constraintErrors, setConstraintErrors] = useState([]);  
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false); 
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const toast = useToast(); 
  
  const handleBack = useCallback(() => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", previousScreen);
      window.parent.postMessage(message, "*");
    } else if (selectMode) {
      hideModal();
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [
    previousState,
    initialFormData,
    currentState,
    currentIndex,
    externalMode,
    selectMode
  ]);  

  
  const getPageTitle = () => {  
    const [screenTitle, screenNumber] = isAddMode(mode) ? screenInfo.ADD : screenInfo.CHANGE;  
    return (  
      <>  
        <span className="title">{screenTitle}</span>  
        <span>{'-'}</span>  
        <span className="screen-number">{screenNumber}</span>  
      </>  
    );  
  };  
   
  
  const submitForm = async (dataForSubmission) => {  
    let url = '';  
    let verb = '';  
    let screenNumber = '';  


    if (isAddMode(currentMode)) {  
        url = 'api/cscCopaySchedule';  
        verb = 'POST';  
        screenNumber = screenInfo.ADD[1];  
    } else {  
        url = 'api/cscCopaySchedule';  
        verb = 'PUT';  
        screenNumber = screenInfo.CHANGE[1];  

        if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {  
            toast.current.show({ severity: 'info', summary: '', detail: 'No Change of Information', life: 3000 });  
            return;  
        }  
    }  

    const data = { ...dataForSubmission, screenNumber };  

    try {  
        const { responseStatus, responseData } = await axios_helper_no_header(verb, url, data, null);  
                    toast.current.show({ severity: 'success', summary: '', detail: responseStatus.message, life: 3000 }); 
            setInitialFormData(responseData);
                        if (isAddMode(currentMode)) {
                setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
                currentState = {
                    ...currentState,
                    selectedSchedules: [{ ...responseData,cshCopayScheduleDesc:cshCopayScheduleDesc }],
                    currentIndex: 0,
                };
                const lastRecord = previousState.pop();
                const { paramsData = {} } = lastRecord;
                 const newStateVal = [
                  ...previousState,
                  {
                    ...lastRecord,
                    paramsData: { ...paramsData, cscStepNbr: responseData.cscStepNbr },
                  },
                  currentState,
                ];
                navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_STEPS_EDIT, newStateVal);
                setStateVal(newStateVal);
                        }
        else {
          setInitialFormData({...responseData,cshCopayScheduleDesc:cshCopayScheduleDesc});
        }
    } catch (error) {  
        const { responseStatus: { displayErrorFields = null, message } = {} } = error.data;  
        if (displayErrorFields === null) {  
            toast.current.show({ severity: 'error', summary: '', detail: message, life: 3000 });  
        } else {  
            setConstraintErrors(displayErrorFields);  
                    }  
    }
};
  
  const [keyFunc, keyName] = useMemo(() => {  
    const keyFunc = {};  
    const keyName = {};  
    if (selectMode) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    }
   else if (isAddMode(currentMode)) {  
      keyFunc.F12 = handleBack;  
      keyName.F12 = 'Back';  
    } else if (isEditMode(currentMode)) {  
      keyFunc.F12 = handleBack;  
      keyName.F12 = 'Back';  
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);  
      keyName.chmod = 'View';  
    } else if (isReadOnlyMode(currentMode)) {  
      keyFunc.F12 = handleBack;  
      keyName.F12 = 'Back';  
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);  
      keyName.chmod = 'Edit';  
    }  
  
    return [keyFunc, keyName];  
  }, [currentMode, currentIndex,initialFormData,selectMode,handleBack]);  
  
  useEffect(() => {
    const fetchInitialData = async () => {
      const params = isAddMode(currentMode)
        ? { cscCopayScheduleName: cscCopayScheduleName }
        : {
            cscStepNbr: selectMode  
              ?(intialSchedule?.cscStepNbr ? Number(intialSchedule.cscStepNbr) : "")
              : selectedSchedules[currentIndex].cscStepNbr,
          };
  
      let url = isAddMode(currentMode)
        ? `api/cscCopaySchedule/initialFormData/${encodeURIComponent(screenInfo.ADD[1])}`
        : `api/cscCopaySchedule/${encodeURIComponent(
            selectMode ? intialSchedule?.cscCopayScheduleName : cscCopayScheduleName || selectedSchedules[currentIndex].cscCopayScheduleName
          )}`;
  
      const { responseData } = await axios_helper_no_header("GET", url, {}, params);
  
      setInitialFormData({
        ...responseData,
        cscCopayScheduleName: selectMode
          ? intialSchedule.cscCopayScheduleName
          : cscCopayScheduleName || selectedSchedules[currentIndex].cscCopayScheduleName,
          cshCopayScheduleDesc: selectMode
  ? (paramsDesc.find(param => param.source === "ps4BrandCopaySchedule")
      ? sourceData.brandCopayScheduleDesc
      : paramsDesc.find(param => param.source === "ps4GenrcCopaySchedule")
      ? sourceData.genericCopayScheduleDesc
      : intialSchedule.brandCopayScheduleDesc)
  : cshCopayScheduleDesc,
      });
    };
    if (isAddMode(currentMode) || selectedSchedules.length) {
      fetchInitialData();
    }
  }, [mode, currentIndex, selectMode,intialSchedule,externalMode]); 


  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });
  
  return (  
    <div className="grid container">  
      <div className="col col-12">  
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />  
      </div>  
      <div className="col col-12">  
        <h1>{getPageTitle()}</h1>  
      </div>  
      <div className="col col-12">  
        <Form  
          formData={initialFormData}  
          formFields={formFields}  
          mode={currentMode}  
          submitFormData={submitForm}  
          constraintErrors={constraintErrors}  
        />  
      </div>  
    </div>  
  );  
};  
  
export default CopayScheduleStepForm;